<template>
  <div class="text-block block-card card-border big-card-block ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <v-icon class="white--text">email</v-icon>
            </div>

            <h4>
              Email 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body" v-if="validData">
            <label for="">To</label>
            <vTextareaAutocomplete 
              v-model="data.to" 
              :type="'textfield'"
              :validation-rules="requireRules"/>

            <label >CC</label>
            <vTextareaAutocomplete 
              v-model="data.cc" 
              :type="'textfield'"
              />

            <label >BCC</label>
            <vTextareaAutocomplete 
              v-model="data.bcc" 
              :type="'textfield'"
              />

            <v-layout 
              row 
              wrap 
              class="align-center">
              <v-flex 
                xs9 
                class="pa-0">
                <label >Subject</label>
                <vTextareaAutocomplete 
                  v-model="data.subject" 
                  :type="'textfield'" 
                  :validation-rules="requireRules"/>
              </v-flex>
              <v-flex xs3>
                <v-switch 
                  v-model="data.useTemplate" 
                  label="Use Template"/>
              </v-flex>
            </v-layout>

            <label>Body</label>
            <quill-editor 
              v-if="!data.useTemplate"
              :id="'email-body-editor-' + index"
              :key="'email-body-editor-' + index"
              v-model="data.bodyText"
              :options="emailBodyEditorOptions"
              class="email-body-editor"
            />
            <v-autocomplete
              v-else
              :items="variables"
              v-model="data.bodyAttributes"
              :error="data.bodyAttributes && data.bodyAttributes.length < 0"
              :error-messages="data.bodyAttributes && data.bodyAttributes.length < 0? 'Attribute is Required':'' "
              item-text="variable"
              class="left-radius"
              item-value="variable"
              outline
              chips
              multiple
              solo
            >
              <template v-slot:selection="dataList">
                <v-chip
                  :selected="dataList.selected"
                  close
                  color="#333"
                  @input="data.bodyAttributes.splice(data.bodyAttributes.indexOf(dataList.item.variable), 1)"
                >
                  <strong>{{ dataList.item.variable }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>

          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'CardEmail',
  components: {
    quillEditor,
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      emailBodyEditorOptions: {
        placeholder: 'Write the email body',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean']
          ]
        }
      },
      requireRules: [v => !!v || 'Field is required']
    }
  },

  computed: {
    variables() {
      return this.$store.state.blocksBuild.variables
    }
  },
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {}
}
</script>

<style>
.email-body-editor .ql-container {
  min-height: 400px;
}

.email-body-editor .ql-editor {
  min-height: 358px;
}
</style>
